/**
 * Converts backend division to country zone type
 */
export const division2CountryZoneAdapter = division => {
  // create a country zone template
  const countryZone = {
    id: division.id,
    title: division.name,
    isNewMethod: division.is_new_method,
    geoJson: {
      type: 'FeatureCollection',
      features: [],
    },
  }

  // loop each shape (i.e. points array) in division data
  division.geometry.forEach(points => {
    // create a feature template
    const feature = {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Polygon',
        coordinates: [],
      },
    }

    const featureCoords = []
    // parse & push each shape/points into feature's geometry coordinates
    // for more information about GeoJson feature object see http://geojson.io
    points.forEach(point => {
      // split comma separated division shape coordinates
      const [x, y] = point.replace(/ /g, '').split(',')
      featureCoords.push([Number(y), Number(x)])
    })

    // check first and last coordinates for equality
    // if not equal add first item to end of the array
    const len = featureCoords.length
    if (featureCoords[0].join() !== featureCoords[len - 1].join())
      featureCoords.push(featureCoords[0])

    feature.geometry.coordinates.push(featureCoords)

    countryZone.geoJson.features.push(feature)
  })

  return countryZone
}

/**
 * Converts country zone to backend division type
 */
export const countryZone2DivisionAdapter = ({
  id,
  title,
  geoJson,
  isNewMethod,
}) => {
  // create a division template
  const division = {
    id,
    name: title,
    geometry: [],
    is_new_method: isNewMethod,
  }

  // loop each feature in geoJson
  geoJson.features.forEach(feature => {
    const coords = feature.geometry.coordinates[0]
    const commaSeparatedCoords = []
    coords.forEach(coord => commaSeparatedCoords.push(coord.reverse().join()))
    division.geometry.push(commaSeparatedCoords)
  })

  return division
}
